import { Box, IconButton, Input } from '@mui/material';
import React from 'react';
import _ from 'lodash';
import { CloseOutlined, Search } from '@mui/icons-material';
import { useQueryParams } from '../../../providers/QueryParamsProvider';
import { useURLSearchHandler } from '../../dev-express/table-components/toolbar/useURLSearchHandler';

const TableSearch = () => {
  const queryParams = useQueryParams();
  const [input, setInput] = React.useState(queryParams.query.search);
  const handleSearch = useURLSearchHandler();

  const onSearch = _.debounce((e) => {
    const { value } = e.target;
    handleSearch(value);
  }, 500);

  const handleClearInput = () => {
    setInput('');
    handleSearch('');
  };

  return (
    <Box position="relative">
      <Input
        type="text"
        placeholder="Search..."
        value={input}
        onChange={(event) => {
          onSearch(event);
          setInput(event.target.value);
        }}
        sx={{
          '& .MuiInputBase-input': {
            height: '0.85rem',
            borderRadius: '10px',
            width: '20rem',
          },
        }}
      />
      <Box
        position="absolute"
        top="50%"
        right={3}
        style={{ transform: 'translateY(-50%)' }}
      >
        <IconButton onClick={handleClearInput}>
          {input === '' ? <Search /> : <CloseOutlined />}
        </IconButton>
      </Box>
    </Box>
  );
};

export default TableSearch;
